import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home as HomeIcon, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const { t } = useTranslation();

  // SEO: signal to Googlebot/Bingbot that this page is genuinely missing.
  // This sets a meta robots "noindex" and a prerender status code,
  // so search engines remove stale Wix URLs from their index instead of
  // showing them as live pages.
  useEffect(() => {
    document.title = '404 — Page Not Found | Seli Marine';

    // noindex meta tag
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    // prerender / static-site renderer status hint
    const prerender = document.createElement('meta');
    prerender.name = 'prerender-status-code';
    prerender.content = '404';
    document.head.appendChild(prerender);

    return () => {
      document.head.removeChild(meta);
      document.head.removeChild(prerender);
    };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl md:text-9xl font-bold text-amber-500 mb-4">404</div>
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Page Not Found
        </h1>
        <p className="text-blue-200 mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-lg transition-all"
            data-testid="not-found-home"
          >
            <HomeIcon className="mr-2" size={20} />
            {t('nav.home')}
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-6 py-3 bg-transparent border-2 border-white hover:bg-white/10 text-white font-semibold rounded-lg transition-all"
            data-testid="not-found-contact"
          >
            <ArrowLeft className="mr-2" size={20} />
            {t('nav.contact')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
